'use client'

import * as React from 'react'
import ReactDOM from 'react-dom'

interface PreloadImageProps {
  imageUrl: string
}

export function PreloadImage({ imageUrl }: PreloadImageProps) {
  React.useEffect(() => {
    if (imageUrl) {
      ReactDOM.preload(imageUrl, {
        // Preload banner image
        // https://nextjs.org/docs/app/api-reference/functions/generate-metadata#link-relpreload
        // @ts-ignore
        as: 'image',
        fetchPriority: 'high',
      })
    }
  }, [imageUrl])

  return null
}
